import { matchRoutes } from 'react-router-dom';

export type RouteMatches = ReturnType<typeof matchRoutes>;

export const findFallbackSiblingPath = (
  routeMatches: RouteMatches,
  visitedPaths: string[],
): string | null => {
  /*   Only applies for nested routes (depth >= 2), not root-level routes.
  Depth >= 2 means we're in a nested context like /settings/admins or /settings/application/feature-toggling.
  This is where tab-based navigation typically exists. */
  const parentMatch = routeMatches?.at(-3);
  const siblings = parentMatch?.route.children ?? [];

  for (const sibling of siblings) {
    const siblingPath = sibling.path;

    // skip index routes and visited paths
    if (
      !siblingPath ||
      visitedPaths.some((path) => path.endsWith(siblingPath))
    ) {
      continue;
    }

    return siblingPath;
  }

  return null;
};
